import { render, staticRenderFns } from "./Exempt.vue?vue&type=template&id=22e77330&scoped=true&"
import script from "./Exempt.vue?vue&type=script&lang=js&"
export * from "./Exempt.vue?vue&type=script&lang=js&"
import style0 from "./Exempt.vue?vue&type=style&index=0&id=22e77330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e77330",
  null
  
)

export default component.exports